import bridge from '@vkontakte/vk-bridge';

/**
 * Обязательный вызов в VK Mini App до Storage API (tech-spec §16.2).
 */
export async function initVkMiniApp(): Promise<void> {
  await bridge.send('VKWebAppInit', {});
}
